<template>
  <div>
    <div id="map" style="height: 400px;"></div>
    <div>
      <p>اضغط على الخريطة وضع المؤشر على العنوان الذي تريده</p>
    </div>
  </div>
</template>

<script>
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import customMarkerIcon from '../../assets/images/mark.png';

export default {
  data() {
    return {
      map: null,
      marker: null,
      markerLatLng: { lat: 31.0416, lng: 31.3796 }, // Initial marker position
    };
  },
  mounted() {
    this.initializeMap();
  },
  methods: {
    initializeMap() {
      this.map = L.map('map').setView([this.markerLatLng.lat, this.markerLatLng.lng], 13);

      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19,
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      }).addTo(this.map);

      const customIcon = L.icon({
        iconUrl: customMarkerIcon,
        iconSize: [32, 32],
        iconAnchor: [16, 32],
        popupAnchor: [0, -32],
      });

      this.marker = L.marker([this.markerLatLng.lat, this.markerLatLng.lng], { icon: customIcon })
        .addTo(this.map)
        .bindPopup('الفرسان | AlFursan')
        .openPopup();

      // Add a click event listener to the map to change the marker's position
      this.map.on('click', this.onMapClick);
    },
    onMapClick(event) {
      // Get the clicked coordinates
      const clickedLatLng = event.latlng;

      // Update the marker's new position
      this.marker.setLatLng(clickedLatLng);

      // Update the displayed latitude and longitude
      this.markerLatLng = { lat: clickedLatLng.lat, lng: clickedLatLng.lng };

      // Emit the updated latitude and longitude to the parent component
      this.$emit('update:markerLatLng', this.markerLatLng);
    },
  },
};
</script>

<style scoped>
#map {
  width: 100%;
}
</style>
